<template>
  <div class="news-list">
    <h2>相關文章</h2>
    <div v-for="item in list" :key="item.newsId" class="news-item items-center hand" @click="toDetails(item)">


      <img :src="item.newsImage" />
      <div class="info">
        <time>{{ item.releaseTime }}</time>
        <h3>{{ item.newsTitle }}</h3>
      </div>


    </div>
  </div>
</template>

<script>
import { getNewsList } from "@/assets/api/news.js";
export default {

  props: {
    author: {
      type: String,
    }
  },

  watch: {
    author() {
      this.getList()
    }
  },

  data() {
    return {
      list: [],
    }
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      if (!this.author) return;

      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        pageNum: 1,
        pageSize: 5,
        slideshow: 0,
        author: this.author,
      }).then((res) => {
        this.list = res.data.rows.map((item) => {
          item.newsImage = !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage;
          return item;
        });
      });

    },
    generateSlug(title) {
      // 将标题中的空格替换为连字符
      let slug = title.toLowerCase().replace(/\s+/g, '-');
      // 将连字符替换为单个连字符
      slug = slug.replace(/-+/g, '');
      slug = slug.replace(/:+/g, '');
      return slug;
    },

    toDetails(item) {
      console.log(this.$route.path)
      if (item.url) {
        window.open(item.url, "_blank");
      } else {

        if (item.price > 0) {
          const path = `/expert-details/${item.newsId}`;
          if (this.$route.path.indexOf('/expert-details') === 0) {
            this.$router.replace({
              path,
            });
          } else {
            this.$router.push({
              path,
            });
          }
        } else {
          localStorage.setItem('newsId', item.newsId);
          let path = item.seoUrl ? item.seoUrl : item.newsId

          path = `/${path}.html`;

          if (this.$route.path.indexOf('/article-details') === 0) {
            this.$router.replace({
              path,
            });
          } else {
            this.$router.push({
              path,
            });
          }


        }
      }
    },


  }
}
</script>

<style lang="less" scoped>
.news-list {
  h2 {
    font-family: NotoSansCJKTC;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 29px;
    letter-spacing: normal;
    text-align: left;
    color: #222;
    padding: 6px 0;
    margin-top: 15px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e13133;
  }

  .news-item {
    margin-bottom: 10px;

    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      margin-right: 10px;
    }

    time {
      font-family: NotoSansCJKTC;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: 0.7px;
      text-align: center;
      color: #8b8b8b;
      margin-bottom: 2px;
    }

    h3 {
      font-family: NotoSansCJKTC;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 2.4px;
      text-align: left;
      color: #222;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
  }
}


@media screen and (max-width: 768px) {
  .news-list {
    padding: 15px;

    h2 {
      font-family: NotoSansCJKTC;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 29px;
      letter-spacing: normal;
      text-align: left;
      color: #222;
      padding: 6px 0;
      margin-top: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e13133;
    }

    .news-item {
      margin-bottom: 10px;

      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        margin-right: 10px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71;
        letter-spacing: 0.7px;
        text-align: center;
        color: #8b8b8b;
        margin-bottom: 2px;
      }

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 2.4px;
        text-align: left;
        color: #222;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/video-details/components/related-article.vue